import {SetSignUpEmail} from "./actions";
import {SetBasisTypes} from "./actions";
export type NotAvailableStateActions = SetSignUpEmail | SetBasisTypes;

export const notAvailableStateActions = [SetSignUpEmail, SetBasisTypes] as const;

export type notAvailableActions = typeof notAvailableStateActions[number];
